import { z } from "zod";

export const nodeEnv = {
  development: "development",
  production: "production",
  test: "test",
} as const;
export const nodeEnvSchema = z.enum(nodeEnv);

export const vercelEnv = {
  production: "production",
  preview: "preview",
  development: "development",
  local: "local", // この値はVercelのドキュメントには存在しません。ローカル開発時に利用します
  test: "test", // この値はVercelのドキュメントには存在しません。テスト時に利用します
};
export const vercelEnvSchema = z.enum(vercelEnv);

/**
 * Basic 認証を実行する環境かどうか（withBasicAuth の enforcement 条件と一致させる）
 *   - production の Vercel 環境ではスキップするため不要
 *   - それ以外の本番ビルド環境（Preview など）では認証を実行するため必須
 *
 * NEXT_PUBLIC_NODE_ENV は process.env.NODE_ENV、
 * NEXT_PUBLIC_VERCEL_ENV は process.env.NEXT_PUBLIC_VERCEL_ENV に対応するため、
 * config.ts の isNodeEnvProd() / isVercelEnvProd() と同じ判定になる。
 */
export function isBasicAuthEnforced() {
  return (
    process.env.NODE_ENV === nodeEnv.production &&
    process.env.NEXT_PUBLIC_VERCEL_ENV !== vercelEnv.production
  );
}

export const zendeskEnv = {
  development: "development",
  production: "production",
  test: "test",
} as const;
export const zendeskEnvSchema = z.enum(zendeskEnv);

const digitalIdentificationAppAlgEnv = {
  RS256: "RS256",
  ES256: "ES256",
} as const;
export const digitalIdentificationAppAlgSchema = z.enum(
  digitalIdentificationAppAlgEnv,
);

const digitalIdentificationAppApiBaseUrlEnv = {
  production_app: "https://auth-and-sign.go.jp/api/",
  sandbox_app: "https://sb-auth-and-sign.go.jp/api/",
  local_app: "http://localhost:8080/",
} as const;
export const digitalIdentificationAppApiBaseUrlSchema = z.enum(
  digitalIdentificationAppApiBaseUrlEnv,
);
